module.exports = __webpack_public_path__ + "static/Mustafa Ismail.bf4bcbcd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mentors/Mustafa Ismail.jpg
// module id = 1224
// module chunks = 6166952557895